const lightboxCloseButtonClickedEvent = new Event('lightboxCloseButtonClicked');
const lightboxSubmitButtonClickedEvent = new Event('lightboxSubmitButtonClicked');

const lightbox = document.getElementById('lightbox');
const lightboxCloseButton = document.getElementById('lightbox-closeButton');
const lightboxSubmitButton = document.getElementById('lightbox-submitButton');

function closeLightbox() {
  'use strict';
  lightbox.style.display = 'none';
  document.body.style.overflow = 'auto';
}

function lightboxElementsPresent() {
  'use strict';
  return lightboxCloseButton && lightboxSubmitButton;
}

if (lightboxElementsPresent) {
  document.body.style.overflow = 'hidden';

  lightboxCloseButton.addEventListener('click', function () {
    'use strict';
    closeLightbox();
    lightbox.dispatchEvent(lightboxCloseButtonClickedEvent);
  });

  lightboxSubmitButton.addEventListener('click', function () {
    'use strict';
    closeLightbox();
    lightbox.dispatchEvent(lightboxSubmitButtonClickedEvent);
  });
}
